import { render, staticRenderFns } from "./LuckyDrawHeaderComponent.vue?vue&type=template&id=c08a514c&scoped=true"
import script from "./LuckyDrawHeaderComponent.vue?vue&type=script&lang=js"
export * from "./LuckyDrawHeaderComponent.vue?vue&type=script&lang=js"
import style0 from "./LuckyDrawHeaderComponent.vue?vue&type=style&index=0&id=c08a514c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c08a514c",
  null
  
)

export default component.exports